module.exports = __webpack_public_path__ + "Flag-74.85ae1a9773efaa023bce677c7e026413.svg";